import axios from "axios";
import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import DataTable from "react-data-table-component";
import { userTableCustomStyles } from "../../utils/TableCustomStyles";
import Select from "react-select";

function SlotRateSheet() {
  const addform = useRef(null);
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [slotAgreementData, setSlotAgreementData] = useState([]);
  const [containerTypeData, setContainerTypeData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] = useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage['userrole']  
  const user_id = sessionStorage['id']
  const [loggedInUser, setLoggedInUser] = useState(null);

  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasFullScreen, setCanvasFullScreen] = useState(false);

  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);

  const [recordForDelete, setRecordForDelete] = useState(null);

  const [showSlotAgreementError, setShowSlotAgreementError] = useState(false);
  const [showContainerTypeError, setShowContainerTypeError] = useState(false);
  const [showCargoTypeError, setShowCargoTypeError] = useState(false);
  const [showCurrencyError, setShowCurrencyError] = useState(false);
  const [showRateError, setShowRateError] = useState(false);


  const [showUpdateSlotAgreementError, setShowUpdateSlotAgreementError] = useState(false);
  const [showUpdateContainerTypeError, setShowUpdateContainerTypeError] = useState(false);
  const [showUpdateCargoTypeError, setShowUpdateCargoTypeError] = useState(false);
  const [showUpdateCurrencyError, setShowUpdateCurrencyError] = useState(false);
  const [showUpdateRateError, setShowUpdateRateError] = useState(false);
  

  const [updateId, setUpdateId] = useState("");
  const [updateSlotAgreement, setUpdateSlotAgreement] = useState("");
  const [updateContainerType, setUpdateContainerType] = useState("");
  const [updateCargoType, setUpdateCargoType] = useState("");
  const [updateCurrency, setUpdateCurrency] = useState("");
  const [updateRate, setUpdateRate] = useState(0);


  const getLoggenInUser = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/user/'+user_id);
        if (response) {
            setLoggedInUser(response.data)
        }
    } catch (err) {
        toast.error("Error in fetching user data! Try again.");
    }
  }
  
  const getSlotRate = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/master/slotrate/');
        if (response) {
            setData(response.data)
            setDataPending(false)
        }
        
    } catch (err) {
        toast.error("Error in fetching slot rate data! Try again.");
    }
  }

  const getSlotAgreement = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/master/slotagreement/');
        if (response) {
            setSlotAgreementData(response.data)
        }
    } catch (err) {
        toast.error("Error in fetching slot agreement data! Try again.");
    }
  }

  const getContainerType = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/product/');
        if (response) {
            console.log("resp", response.data)
            const container_data = Array.isArray(response?.data) ? response.data.filter(product => product.type === "CONTAINER"): [];
            setContainerTypeData(container_data)
        }
    } catch (err) {
        toast.error("Error in fetching container type data! Try again.");
    }
  }

  const getCurrency = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/currency/');
        if (response) {
            setCurrencyData(response.data)
        }
    } catch (err) {
        toast.error("Error in fetching currency data! Try again.");
    }
  }

  const getCurrentUserRolePermission = async (roles) => {
        try {
            const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/role/getuserrolepermission?roles='+roles);
            
            const role_permissions_array = []
            for(let i=0; i<response.data?.length; i++){
                for(let j=0; j<response?.data[i]?.permissions_array?.length; j++){
                    if(!role_permissions_array.includes(response?.data[i]?.permissions_array?.[j])){
                        role_permissions_array.push(response?.data[i]?.permissions_array?.[j])
                    }
                }
            }

            if(role_permissions_array){
                setCurrentUserRolePermissionData(role_permissions_array)
            }
              
        } catch (err) {
            toast.error("Error in fetching user role data! Try again.");
        }
      }

  const handleDeleteModalClose = () => {
    setShowDeleteModal(false)
  }

  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true)
    setRecordForDelete(data)
  }

  const handleSetAddData = () => {
    addform.current.slot_agreement.value = ""
    addform.current.container_type.value = ""
    addform.current.cargo_type.value = ""
    addform.current.currency.value = ""
    addform.current.rate.value = ""
  }

  const closeAddForm = () => {
    setShowSlotAgreementError(false)
    setShowContainerTypeError(false)
    setShowCargoTypeError(false)
    setShowCurrencyError(false)
    setShowRateError(false)
  }

  const handleSetUpdateData = (row) => {
    setUpdateId(row.id)
    setUpdateSlotAgreement(row.slot_agreement)
    setUpdateContainerType(row.container_type)
    setUpdateCargoType(row.cargo_type)
    setUpdateCurrency(row.currency)
    setUpdateRate(row.rate)
  }

  useEffect(() => {
    getLoggenInUser()
    getSlotRate()
    getSlotAgreement()
    getContainerType()
    getCurrency()
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role)
  }, [user_role]);

  const columns = [
    {
      name: 'Slot Agreement',
      width: '500px',
      selector: row => row.slot_agreement_data?.operator_data?.name + " ("+ row.slot_agreement_data?.from_port_data?.name +" - "+ row.slot_agreement_data?.to_port_data?.name +")",
      sortable: true,
    },
    {
      name: 'Container Type',
      selector: row => row.container_type_data?.product_name,
      sortable: true,
    },
    {
      name: 'Cargo Type',
      selector: row => row.cargo_type,
      sortable: true,
    },
    {
      name: 'Currency',
      selector: row => row.currency_data?.name +" ("+ row.currency_data?.symbol +")" ,
      sortable: true,
    },
    {
      name: 'Rate',
      selector: row => row.currency_data?.symbol + " " + row.rate,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("master:slotagreement:update")?
          <Button className="btn btn-sm btn-inox-green border-0" title="Update" data-bs-toggle="offcanvas" data-bs-target="#updateSection" onClick={() => handleSetUpdateData(row)}>
            <i className="fa fa-edit"></i>
          </Button>
          :
          ""
        }

        {
          currentUserRolePermissionData?.includes("master:slotagreement:delete")?
          <Button className="btn btn-sm bg-danger border-0 mx-2" title="Delete" onClick={() => handleDeleteModalOpen(row)}>
            <i className="fa fa-trash"></i>
          </Button>
          :
          ""
        }
      </div>,
    }
  ];

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true)
    try {
        const response = await axios.delete(process.env.REACT_APP_BACKEND_API_URL+'/master/slotrate/'+id+'/');
        setShowDeleteModal(false)
        getSlotRate()
        if(response.status == 204){
          toast.success("Record deleted successfully")
        }
    } catch (err) {
        toast.error("Error in deleting record! Try again.");
    }
    getSlotRate()
    setShowDeleteLoader(false)
  }

  const addNewSlotRate = async (e) => {
    e.preventDefault();
    setShowAddLoader(true)

    if(addform.current.slot_agreement.value == ""){
      toast.warning("Slot Agreement is required")
    }
    else if(addform.current.container_type.value == ""){
      toast.warning("Container Type is required")
    }
    else if(addform.current.cargo_type.value == ""){
      toast.warning("Cargo Type is required")
    }
    else if(addform.current.currency.value == ""){
      toast.warning("Currency is required")
    }
    else if(addform.current.rate.value == "" | addform.current.rate.value <= 0){
      toast.warning("Slot Rate is required")
    }
    else{
      const data = {
      slot_agreement: addform.current.slot_agreement.value,
      container_type: addform.current.container_type.value,
      cargo_type: addform.current.cargo_type.value,
      currency: addform.current.currency.value,
      rate: addform.current.rate.value,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
      }

      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL+'/master/slotrate/', data,  
        {
          headers: { 'content-type': 'application/json'}
        }
      );

      if (response.status == "201" ) {
        toast.success("Slot Rate Created Successfully")
      }

      addform.current.slot_agreement.value = ""
      addform.current.container_type.value = ""
      addform.current.cargo_type.value = ""
      addform.current.currency.value = ""
      addform.current.rate.value = ""
      getSlotRate()
      setShowAddCanvas(false)
    }
    setShowAddLoader(false)
  }

  const updateSlotRate = async (e) => {
    e.preventDefault();
    setShowUpdateLoader(true)

    if(updateSlotAgreement == ""){
      toast.warning("Slot Agreement is required")
    }
    else if(updateContainerType == ""){
      toast.warning("Container Type is required")
    }
    else if(updateCargoType == ""){
      toast.warning("Cargo Type is required")
    }
    else if(updateCurrency == ""){
      toast.warning("Currency is required")
    }
    else if(updateRate == "" | updateRate <= 0){
      toast.warning("Slot Rate is required")
    }
    else{
      const id = updateId

      const data = {
        slot_agreement: updateSlotAgreement,
        container_type: updateContainerType,
        cargo_type: updateCargoType,
        currency: updateCurrency,
        rate: updateRate,
        modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
      }

      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL+'/master/slotrate/'+id+'/', data,  
        {
          headers: { 'content-type': 'application/json'}
        }
      );
      if (response.status === 200 ) {
        toast.success("Slot Rate updated Successfully")
      }
      getSlotRate()
      setShowUpdateCanvas(false)
    }
    setShowUpdateLoader(false)
  }

  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div className="page-content-bg">
      <ToastContainer></ToastContainer>
      <TopNavbar sidebarCollapsed={menuDrawerShow} topNavbarStatic={true} sendDataToParent={handleDataFromTopNavBar}/>
      <SideNavbar sidebarCollapsed={menuDrawerShow} activeMenu="RateSheet" activeSubMenu="SlotRateSheet" activeSubMenuLevel1="" permissionFromTopNavbar={dataFromTopNavBar}/>

      <div className={menuDrawerShow ? "row main-content-collapsed text-left py-0" : "row main-content text-left py-0"} >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button className="btn btn-sm btn-inox-green border-0 mx-2" onClick={() => setMenuDrawerShow(!menuDrawerShow)}>
                {menuDrawerShow?
                  <span><i className="fa fa-chevron-left mx-1"></i></span>:
                  <span><i className="fa fa-chevron-right mx-1"></i></span>
                }
              </Button>
              <span className="page-header-text">Slot Rate Sheet</span>
            </div>

            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
            {
              currentUserRolePermissionData?.includes("master:slotagreement:add")?
                <Button className="btn btn-sm btn-inox-green border-0  px-3 float-right" data-bs-toggle="offcanvas" data-bs-target="#addSection"
                onClick={()=> handleSetAddData()}>
                  <i className="fa fa-plus fa-lg text-right" style={{ paddingRight: 10 }}></i>
                  <span className="fw-bold">Add Rate Sheet</span>
                </Button>
              :
                ""
            }
            </div>
          </div>
        </div>

        <div className="col-12 text-left" style={{ marginTop: -5, paddingLeft: 20, paddingRight: 30, zIndex: 100 }}>
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true"/>}
            noDataComponent={<p className="text-center table-no-data">No Data Found</p>}
            pagination
            highlightOnHover
            fixedHeader
            customStyles={userTableCustomStyles}
            dense
          />
        </div>
      </div>

      <Modal size="sm" show={showDeleteModal} onHide={handleDeleteModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>Close</Button>
          <Button variant="danger" onClick={()=> deleteSelectedRecord(recordForDelete?.id)}>
            {showDeleteLoader?
            <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
            :
            "Delete"
            }
            
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Section ------------------- */}
      <div class={canvasFullScreen && showUpdateCanvas?"offcanvas offcanvas-bottom h-100 show":
        !canvasFullScreen && showUpdateCanvas?"offcanvas offcanvas-bottom h-60 show":"offcanvas offcanvas-bottom h-60"} 
        id="updateSection" data-bs-scroll="true" tabindex="-1" aria-labelledby="offcanvasBottomLabel">
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">Update Record</h4>
            </div>
            <div className="col-6">
              <button type="button" class="btn btn-danger btn-sm float-right" data-bs-dismiss="offcanvas" aria-label="Close" title="Close"
              onClick={() => [setShowUpdateCanvas(false)]}>
                  <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen?
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Half Screen" onClick={() => [setCanvasFullScreen(false), setShowUpdateCanvas(true)]}>
                    <i className="fa fa-window-minimize text-white"></i>
                </button>
                :
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Full Screen" onClick={() => [setCanvasFullScreen(true), setShowUpdateCanvas(true)]}>
                    <i className="fa fa-window-maximize text-white"></i>
                </button>
              }
            </div>
          </div>
        </div>

        <div class="offcanvas-body" style={{ paddingLeft: 20, paddingRight: 40 }}>
          <div>
            <form onSubmit={(e) => updateSlotRate(e)}>
              <div className="row">
                <div class={`form-group ${canvasFullScreen?"col-md-4":"col-md-4"} text-left mb-4`}>
                  <label for="slot_agreement">Slot Agreement: <i className="text-danger">*</i><span className="text-danger">{showUpdateSlotAgreementError?" Slot agreement required":""}</span></label>
                  <select name="slot_agreement" class="form-control form-control-sm" 
                          onChange={(e) => setUpdateSlotAgreement(e.target.value)}
                          onBlur={(e) => e.target.value==""?setShowUpdateSlotAgreementError(true):setShowUpdateSlotAgreementError(false)}>
                      <option value="">Select Slot Agreement</option>
                      {slotAgreementData.map(slot_agreement => (
                      <option value={slot_agreement?.id} selected={updateSlotAgreement==slot_agreement.id?true:false}>{slot_agreement?.operator_data?.name} {slot_agreement?.from_port_data?.name} - {slot_agreement?.to_port_data?.name}</option>
                      ))}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  <label for="container_type">Container Type: <i className="text-danger">*</i><span className="text-danger">{showUpdateContainerTypeError?" Container type required":""}</span></label>
                  <select name="container_type" class="form-control form-control-sm"  
                          onChange={(e) => setUpdateContainerType(e.target.value)}
                          onBlur={(e) => e.target.value==""?setShowUpdateContainerTypeError(true):setShowUpdateContainerTypeError(false)}>
                      <option value="">Select Container Type</option>
                      {containerTypeData.map(container => (
                      <option value={container?.id} selected={updateContainerType==container.id?true:false}>{container?.product_name}</option>
                      ))}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  <label for="cargo_type">Cargo Type: <i className="text-danger">*</i><span className="text-danger">{showUpdateCargoTypeError?" Cargo type required":""}</span></label>
                  <select className="form-select form-select-sm" name="cargo_type" 
                          onChange={(e) => setUpdateCargoType(e.target.value)}
                          onBlur={(e) => e.target.value==""?setShowUpdateCargoTypeError(true):setShowUpdateCargoTypeError(false)}>
                    <option value="" selected={updateCargoType==""?true:false}>Select Cargo Type</option>
                    <option value="HAZARDOUS" selected={updateCargoType=="HAZARDOUS"?true:false}>HAZARDOUS</option>
                    <option value="NON_HAZARDOUS" selected={updateCargoType=="NON_HAZARDOUS"?true:false}>NON HAZARDOUS</option>
                    <option value="EMPTY" selected={updateCargoType=="EMPTY"?true:false}>EMPTY</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  <label for="currency">Currency: <i className="text-danger">*</i><span className="text-danger">{showUpdateCurrencyError?" Currency required":""}</span></label>
                  <select name="currency" class="form-control form-control-sm"  
                          onChange={(e) => setUpdateCurrency(e.target.value)}
                          onBlur={(e) => e.target.value==""?setShowUpdateCurrencyError(true):setShowUpdateCurrencyError(false)}>
                      <option value="">Select Currency</option>
                      {currencyData.map(currency => (
                      <option value={currency?.id} selected={updateCurrency==currency.id?true:false}>{currency?.name} {currency?.symbol}</option>
                      ))}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  <label for="rate">Rate: <i className="text-danger">*</i><span className="text-danger">{showUpdateRateError?" Rate required":""}</span></label>
                  <input type="number" class="form-control form-control-sm" id="rate" name="rate" placeholder="Enter Rate"
                  value={updateRate} onChange={(e) => setUpdateRate(e.target.value)}
                  onBlur={(e) => e.target.value=="" | e.target.value <= 0 ?setShowUpdateRateError(true):setShowUpdateRateError(false)}/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-12":"col-md-12"}`}>
                  <Button className="btn btn-inox-green border-0 canvas-button" onClick={(e) => updateSlotRate(e)}>
                    {showUpdateLoader?
                      <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                    :
                    <>
                      <i className="fa fa-edit"></i> <span className="mx-2">Update</span>
                    </>
                    }
                    
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* ------------------------ Update Section ------------------- */}

      {/* ------------------------ Add Section ------------------- */}
      <div class={canvasFullScreen && showAddCanvas?"offcanvas offcanvas-bottom h-100 show":
        !canvasFullScreen && showAddCanvas?"offcanvas offcanvas-bottom h-60 show":"offcanvas offcanvas-bottom h-60"} 
        data-bs-scroll="true" tabindex="-1" id="addSection" aria-labelledby="offcanvasBottomLabel">
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">Add New Record</h4>
            </div>
            <div className="col-6">
              <button type="button" class="btn btn-danger btn-sm float-right" data-bs-dismiss="offcanvas" aria-label="Close" title="Close"
              onClick={() => [setShowAddCanvas(false), closeAddForm()]}>
                  <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen?
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Half Screen" onClick={() => [setCanvasFullScreen(false), setShowAddCanvas(true)]}>
                    <i className="fa fa-window-minimize text-white"></i>
                </button>
                :
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Full Screen" onClick={() => [setCanvasFullScreen(true), setShowAddCanvas(true)]}>
                    <i className="fa fa-window-maximize text-white"></i>
                </button>
              }
            </div>
          </div>
        </div>

        <div class="offcanvas-body" style={{ paddingLeft: 20, paddingRight: 40 }}>
            <form ref={addform} onSubmit={(e) => addNewSlotRate(e)}>
              <div className="row">
                <div class={`form-group ${canvasFullScreen?"col-md-4":"col-md-4"} text-left mb-4`}>
                  <label for="slot_agreement">Slot Agreement: <i className="text-danger">*</i><span className="text-danger">{showSlotAgreementError?" Slot agreement required":""}</span></label>
                  <select name="slot_agreement" class="form-control form-control-sm" onBlur={(e) => e.target.value==""?setShowSlotAgreementError(true):setShowSlotAgreementError(false)}>
                      <option value="">Select Slot Agreement</option>
                      {slotAgreementData.map(slot_agreement => (
                      <option value={slot_agreement?.id}>{slot_agreement?.operator_data?.name} {slot_agreement?.from_port_data?.name} - {slot_agreement?.to_port_data?.name}</option>
                      ))}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  <label for="container_type">Container Type: <i className="text-danger">*</i><span className="text-danger">{showContainerTypeError?" Container type required":""}</span></label>
                  <select name="container_type" class="form-control form-control-sm"
                          onBlur={(e) => e.target.value==""?setShowContainerTypeError(true):setShowContainerTypeError(false)}>
                      <option value="">Select Container Type</option>
                      {containerTypeData.map(container => (
                      <option value={container?.id} selected={updateContainerType==container.id?true:false}>{container?.product_name}</option>
                      ))}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  <label for="cargo_type">Cargo Type: <i className="text-danger">*</i><span className="text-danger">{showCargoTypeError?" Cargo type required":""}</span></label>
                  <select className="form-select form-select-sm" name="cargo_type" onBlur={(e) => e.target.value==""?setShowCargoTypeError(true):setShowCargoTypeError(false)}>
                    <option value="">Select Cargo Type</option>
                    <option value="HAZARDOUS">HAZARDOUS</option>
                    <option value="NON_HAZARDOUS">NON HAZARDOUS</option>
                    <option value="EMPTY">EMPTY</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  <label for="currency">Currency: <i className="text-danger">*</i><span className="text-danger">{showCurrencyError?" Currency required":""}</span></label>
                  <select name="currency" class="form-control form-control-sm" onBlur={(e) => e.target.value==""?setShowCurrencyError(true):setShowCurrencyError(false)}>
                      <option value="">Select Currency</option>
                      {currencyData.map(currency => (
                      <option value={currency?.id}>{currency?.name} {currency?.symbol}</option>
                      ))}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  <label for="rate">Rate: <i className="text-danger">*</i><span className="text-danger">{showRateError?" Rate required":""}</span></label>
                  <input type="number" class="form-control form-control-sm" id="rate" name="rate" placeholder="Enter Rate"
                        onBlur={(e) => e.target.value=="" | e.target.value <= 0 ?setShowRateError(true):setShowRateError(false)}/>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-12":"col-md-12"}`}>
                  <Button className="btn btn-inox-green border-0 canvas-button" onClick={(e) => addNewSlotRate(e)}>
                  {showAddLoader?
                      <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                    :
                    <>
                      <i className="fa fa-plus"></i> <span className="mx-2">Add</span>
                    </>
                  }
                  </Button>
                </div>
              </div>
            </form>
        </div>
      </div>
      {/* ------------------------ Add Section ------------------- */}
    </div>
  );
}

export default SlotRateSheet;
